import { render, staticRenderFns } from "./WorkspaceSwitcher.vue?vue&type=template&id=87610e44&"
import script from "./WorkspaceSwitcher.vue?vue&type=script&lang=js&"
export * from "./WorkspaceSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports